import { NgModule } from '@angular/core';
import { AirlineApiService } from './airlineapi.service';
import { ApiUrlProvider } from './apiUrl.provider';
import { AuthApiService } from './authApi.service';
import { JanusUrlProvider } from './janusUrl.provider';
import { LocationsApiUrlProvider } from './locationsApiUrl.provider';

@NgModule({
  providers: [
    AuthApiService,
    ApiUrlProvider,
    LocationsApiUrlProvider,
    JanusUrlProvider,
    AirlineApiService,
  ],
})
export class AppApiServicesModule {}
